import update from 'immutability-helper';
import {
  GET_MYTRIP_LIST_SUCCESS,
  GET_NEXT_MYTRIP_LIST_SUCCESS,
  SHOW_SHARE_MYTRIP_BOX,
  CLEAN_SHARE_MYTRIP_BOX,
  POST_TRIP_PUBLIC_STATUS_SUCCESS,
  SHOW_ADD_GROUP_BOX,
  CLEAN_ADD_GROUP_BOX,
  SET_INVITATION_LINK,
  UPDATE_MEMBERS_OF_GROUP,
  DELETE_MY_TRIP_SUCCESS,
  DELETE_MY_TRIP_FAIL,
  SET_TRIP_ITEM_LOADING,
  ONBOARDING_BOX,
  RESET_MYTRIP_PAGE_STATE,
  CHECK_DELETE_MYTRIPS,
  GET_TEMPLETE_TRIP,
  SET_ONBOARDING_STEP,
  ADD_TRIP_SUCCESS,
  ADD_TRIP_LOADING,
  COPY_ON_BOARDING,
  SET_ONBOARDING_DATE,
  REQUEST,
} from '../actions/action_types';
import { ADD_POI_OF_POIPAGE_TO_TRIP } from '../actionTypes/poiDetail';
import { ONBOARDING_STEP } from '../constants/onboarding';
import { GET_RECOMMEND_TRIPS, GET_TRIP_LIST } from '../actionTypes/trip';
import { TRIP_PERMISSION } from '../constants/trips';

const initState = {
  currentTrip: {},
  loadingTripID: '',
  isShowOnboardingPopup: false,
  isShowAddGroupBox: false,
  isShowShareTripBox: false,
  isShowCheckDeleteBox: false,
  onboardingData: {
    step: ONBOARDING_STEP.SELECT_TEMPLETE,
    data: [],
    isGetDataLoading: false,
    isCopyLoading: false,
    tripName: '',
    startDate: '',
    id: '',
    authorID: '',
  },
  tripData: [],
  hasMore: false,
  invitationLink: '',
  membersOfGroup: {
    members: [],
    owner: {},
  },
  recommendTrips: [],
  hasEditableTrips: false,
  requestState: REQUEST.INIT,
};
const copyState = JSON.parse(JSON.stringify(initState));

export default (state = copyState, action) => {
  switch (action.type) {
    case GET_MYTRIP_LIST_SUCCESS:
      return {
        ...state,
        totalCount: action.payload.totalCount,
        skip: action.payload.skip,
        tripData: action.payload.trips,
        hasMore: action.payload.totalCount > action.payload.trips.length,
      };
    case GET_NEXT_MYTRIP_LIST_SUCCESS:
      return {
        ...state,
        totalCount: action.payload.totalCount,
        skip: action.payload.skip,
        tripData: [...state.tripData, ...action.payload.trips],
        hasMore:
          action.payload.totalCount >
          state.tripData.length + action.payload.trips.length,
      };

    case ADD_POI_OF_POIPAGE_TO_TRIP.FAIL:
    case ADD_POI_OF_POIPAGE_TO_TRIP.SUCCESS:
    case RESET_MYTRIP_PAGE_STATE:
      return initState;
    case ONBOARDING_BOX.SHOW:
      return {
        ...state,
        isShowOnboardingPopup: true,
      };
    case ONBOARDING_BOX.CLOSE:
      return {
        ...state,
        isShowOnboardingPopup: false,
        onboardingData: {
          ...state.onboardingData,
          step: ONBOARDING_STEP.SELECT_TEMPLETE,
          data: [],
          isGetDataLoading: false,
          isCopyLoading: false,
        },
      };
    case SHOW_SHARE_MYTRIP_BOX:
      return {
        ...state,
        currentTrip: action.payload,
        isShowShareTripBox: true,
      };
    case CLEAN_SHARE_MYTRIP_BOX:
      return {
        ...state,
        currentTrip: {},
        isShowShareTripBox: false,
      };
    case POST_TRIP_PUBLIC_STATUS_SUCCESS:
      return setPublicChangeTripData(state, action.payload);
    case SHOW_ADD_GROUP_BOX:
      return {
        ...state,
        isShowAddGroupBox: true,
        loadingTripID: '',
        currentTrip: action.payload.trip,
        membersOfGroup: action.payload.membersOfGroup,
      };
    case CLEAN_ADD_GROUP_BOX:
      return {
        ...state,
        isShowAddGroupBox: false,
        loadingTripID: '',
        currentTrip: {},
        membersOfGroup: {
          members: [],
          owner: {},
        },
        invitationLink: '',
      };
    case CHECK_DELETE_MYTRIPS.SHOW:
      return {
        ...state,
        isShowCheckDeleteBox: true,
        loadingTripID: '',
        currentTrip: action.payload.current,
      };
    case CHECK_DELETE_MYTRIPS.CLOSE:
      return {
        ...state,
        isShowCheckDeleteBox: false,
        loadingTripID: '',
        currentTrip: {},
      };
    case UPDATE_MEMBERS_OF_GROUP:
      return updateMembersOfGroup(state, action.payload);
    case SET_INVITATION_LINK:
      return {
        ...state,
        invitationLink: action.payload,
      };
    case DELETE_MY_TRIP_SUCCESS:
      return deleteMyTrip(state, action.payload);
    case DELETE_MY_TRIP_FAIL:
      return {
        ...state,
        loadingTripID: '',
        currentTrip: {},
        isShowCheckDeleteBox: false,
      };
    case SET_TRIP_ITEM_LOADING:
      return {
        ...state,
        loadingTripID: action.payload,
      };
    case GET_TEMPLETE_TRIP.LOADING:
      return {
        ...state,
        onboardingData: {
          ...state.onboardingData,
          step: ONBOARDING_STEP.SELECT_TEMPLETE,
          data: [],
          isGetDataLoading: true,
        },
      };
    case GET_TEMPLETE_TRIP.SUCCESS:
      return {
        ...state,
        onboardingData: {
          ...state.onboardingData,
          data: action.payload.data,
          isGetDataLoading: false,
        },
      };
    case GET_TEMPLETE_TRIP.FAIL:
      return {
        ...state,
        onboardingData: {
          ...state.onboardingData,
          data: [],
          isGetDataLoading: false,
        },
      };
    case SET_ONBOARDING_STEP.GO_ADD_TRIP:
      return {
        ...state,
        onboardingData: {
          ...state.onboardingData,
          step: ONBOARDING_STEP.ADD_TRIP,
        },
      };
    case SET_ONBOARDING_STEP.BACK_TEMPLETE:
      return {
        ...state,
        onboardingData: {
          ...state.onboardingData,
          step: ONBOARDING_STEP.SELECT_TEMPLETE,
        },
      };
    case SET_ONBOARDING_STEP.GO_DATE:
      return {
        ...state,
        onboardingData: {
          ...state.onboardingData,
          step: ONBOARDING_STEP.SELECT_DATE,
          tripName: action.payload.tripName,
          id: action.payload.id,
          authorID: action.payload.authorID,
        },
      };
    case SET_ONBOARDING_STEP.GO_DATE_RECOMMEND_TRIP:
      return {
        ...state,
        onboardingData: {
          ...state.onboardingData,
          step: ONBOARDING_STEP.SELECT_RECOMMEND_TRIP_DATE,
          tripName: action.payload.tripName,
          id: action.payload.id,
          authorID: action.payload.authorID,
        },
        isShowOnboardingPopup: true,
      };
    case COPY_ON_BOARDING.LOADING:
      return {
        ...state,
        onboardingData: {
          ...state.onboardingData,
          isCopyLoading: true,
        },
      };
    case COPY_ON_BOARDING.SUCCESS:
      return {
        ...state,
        onboardingData: {
          ...state.onboardingData,
          isCopyLoading: false,
        },
        currentTrip: {
          ...action.payload.results,
        },
      };
    case COPY_ON_BOARDING.FAIL:
      return {
        ...state,
        onboardingData: {
          ...state.onboardingData,
          isCopyLoading: false,
        },
      };
    case SET_ONBOARDING_DATE:
      return {
        ...state,
        onboardingData: {
          ...state.onboardingData,
          startDate: action.payload.startDate,
        },
      };
    case ADD_TRIP_LOADING:
      return {
        ...state,
        onboardingData: {
          ...state.onboardingData,
          step: ONBOARDING_STEP.ADD_TRIP,
        },
      };
    case ADD_TRIP_SUCCESS:
      return {
        ...state,
        onboardingData: {
          ...state.onboardingData,
          step: ONBOARDING_STEP.ADD_TRIP,
        },
        currentTrip: {
          ...action.payload.results,
        },
      };
    case GET_RECOMMEND_TRIPS.SUCCESS:
      return {
        ...state,
        recommendTrips: action.payload.trips,
      };
    case GET_TRIP_LIST.LOADING:
      return {
        ...state,
        requestState: REQUEST.LOADING,
      };
    case GET_TRIP_LIST.SUCCESS: {
      const { data, permission } = action.payload;
      const hasEditableTrips =
        permission === TRIP_PERMISSION.EDIT && data.length > 0;
      return {
        ...state,
        hasEditableTrips,
        requestState: REQUEST.SUCCESS,
      };
    }
    case GET_TRIP_LIST.FAIL:
      return {
        ...state,
        requestState: REQUEST.FAIL,
      };
    default:
      return state;
  }
};

const setPublicChangeTripData = (state, payload) => {
  const index = state.tripData.findIndex(item => item._id === payload.tripID);
  if (index === -1) {
    return {
      ...state,
    };
  }
  const newTripData = [...state.tripData];
  newTripData[index].publicStatus = payload.status;
  return {
    ...state,
    tripData: [...newTripData],
  };
};

const updateMembersOfGroup = (state, payload) => {
  const { members: membersData } = state.membersOfGroup;
  const newMemberData = membersData.filter(item => item.id !== payload);

  const { _id } = state.currentTrip;
  const { tripData } = state;
  const index = tripData.findIndex(item => item._id === _id);

  const newCompanions = tripData[index].companions.filter(
    item => item.parseFriendObjectId !== payload,
  );
  const newCountOfCompanions = Number(tripData[index].countOfCompanions) - 1;

  // membersOfGroup 與 tripData 內對應行程的成員資料都要更新
  const newState = update(state, {
    membersOfGroup: {
      members: { $set: newMemberData },
    },
    tripData: {
      [index]: {
        companions: { $set: newCompanions },
        countOfCompanions: { $set: String(newCountOfCompanions) },
      },
    },
    loadingTripID: { $set: '' },
  });
  return newState;
};

const deleteMyTrip = (state, payload) => {
  const deleteCount = 1; // 刪除數量

  const index = state.tripData.findIndex(item => item._id === payload);
  const newState = update(state, {
    tripData: { $splice: [[index, deleteCount]] },
    isShowCheckDeleteBox: { $set: false },
    loadingTripID: { $set: '' },
    currentTrip: { $set: {} },
  });
  return newState;
};
